$(document).ready(function() {
    $('.collection-slider-inner').slick({
        dots: false,
        infinite: true,
        speed: 600,
        arrows: true,
        slidesToShow: 3,
        autoplay: false,
        autoplaySpeed: 2000,
        slidesToScroll: 1,
        prevArrow: '<button type="button" class="slick-prev"><i class="fas fa-chevron-left"></i></button>',
        nextArrow: '<button type="button" class="slick-next"><i class="fas fa-chevron-right"></i></button>',
        responsive: [{
            breakpoint: 1024,
            settings: { slidesToShow: 3, slidesToScroll: 1, infinite: true, dots: false }
        }, {
            breakpoint: 992,
            settings: { slidesToShow: 3, slidesToScroll: 1 }
        }, {
            breakpoint: 768,
            settings: { slidesToShow: 2, slidesToScroll: 1 }
        }, {
            breakpoint: 480,
            settings: { slidesToShow: 2, slidesToScroll: 1 }
        }]
    });

  function initializeYouMayLikeSlick() {
        $('.has-you-may-like-slider').slick({
            dots: true,
            infinite: true,
            speed: 600,
            arrows: false,
            slidesToShow: 1,
            autoplay: false,
            autoplaySpeed: 2000,
            slidesToScroll: 1,
            responsive: [{
                breakpoint: 1024,
                settings: { slidesToShow: 1, slidesToScroll: 1, infinite: true, dots: true }
            }, {
                breakpoint: 992,
                settings: { slidesToShow: 1, slidesToScroll: 1 }
            }, {
                breakpoint: 768,
                settings: { slidesToShow: 1, slidesToScroll: 1 }
            }, {
                breakpoint: 480,
                settings: { slidesToShow: 1, slidesToScroll: 1 }
            }]
        });
    }

    initializeYouMayLikeSlick();

    $(window).resize(function() {
        $('.has-you-may-like-slider').slick('unslick'); // Remove the previous instance
        initializeYouMayLikeSlick(); // Initialize again
    });

    // Function to (re)initialize the product slider
    function initializeProductSlider() {
        $('.card-product-slider').not('.slick-initialized').slick({
            dots: true,
            infinite: true,
            speed: 600,
            arrows: false,
            slidesToShow: 1,
            autoplay: false,
            autoplaySpeed: 2000,
            slidesToScroll: 1,
            responsive: [{
                breakpoint: 1024,
                settings: { slidesToShow: 1, slidesToScroll: 1, infinite: true, dots: true }
            }, {
                breakpoint: 992,
                settings: { slidesToShow: 1, slidesToScroll: 1 }
            }, {
                breakpoint: 768,
                settings: { slidesToShow: 1, slidesToScroll: 1 }
            }, {
                breakpoint: 480,
                settings: { slidesToShow: 1, slidesToScroll: 1 }
            }]
        });
    }

    initializeProductSlider(); // Initialize the slider on page load

    // Function to reset the product slider
    function resetSlider(slidesToShow) {
        $('.card-product-slider').slick('unslick'); // Destroy the existing instance
        initializeProductSlider(); // Reinitialize the slider
        $('.card-product-slider').slick('slickSetOption', 'slidesToShow', slidesToShow, true); // Set new option
    }

    // Event handler for switching views
    $('#two-product, #three-product').on('click', function() {
        var isTwoActive = $(this).is('#two-product');

        $('#two-product, #three-product').removeClass('active');
        $(this).addClass('active');

        if (isTwoActive) {
            $('#product-grid').addClass('two-active');
            resetSlider(1); // Update slider for 2x2 grid
        } else {
            $('#product-grid').removeClass('two-active');
            resetSlider(1); // Update slider for 3x3 grid
        }
    });

  $('.featured-collection--slider').slick({
        dots: true,
        infinite: true,
        speed: 600,
        arrows: true,
        slidesToShow: 4,
        autoplay: false,
        autoplaySpeed: 2000,
        slidesToScroll: 1,
        prevArrow: '<button type="button" class="slick-prev"><i class="fas fa-chevron-left"></i></button>',
        nextArrow: '<button type="button" class="slick-next"><i class="fas fa-chevron-right"></i></button>',
        responsive: [{
            breakpoint: 992,
            settings: { slidesToShow: 2, slidesToScroll: 1, infinite: true, dots: false }
        }, {
            breakpoint: 768,
            settings: { slidesToShow: 2, slidesToScroll: 1 }
        }, {
            breakpoint: 480,
            settings: { slidesToShow: 1, slidesToScroll: 1 }
        }]
    });

  $('.simple-menu-drawer-item').first().css('border-top', '1px solid #e2e2e2');
});
